import { Button, Modal } from "antd";
import React from "react";
import { useState } from "react";
import GlobalPaymentsForm from "./GlobalPaymentsForm";
import LoadingOverlay from "./LoadingOverlay";
import ReCAPTCHA from "react-google-recaptcha";

export default function GlobalPaymentsButton(props) {

    const { amount = "" } = props;
    const [loading, setLoading] = useState(false);
    const [enabled, setEnabled] = useState(false);
    const [captcha, setCaptcha] = useState("")
    const recaptchaRef = React.createRef();

    const [open, setOpen] = useState("")


    const onChange = (e) => {
        setCaptcha(e);
        setEnabled(true);
    }

    const onClose = () => {
        setEnabled(false);
        setOpen(false);
        
       
    }

    return (
        <>
            <Modal destroyOnClose bodyStyle={{ "paddingBottom": "0px" }} onCancel={() => onClose()} title="Global Payments" width={350} footer={null} open={open}>
                <GlobalPaymentsForm captcha={captcha} onClose={onClose} setLoading={setLoading} setOpen={setOpen} amount={amount} />
            </Modal>

            <div style={{"width" : "164px", "margin" : "0 auto", "height" : (enabled) ? "0px" : "auto", "opacity" : (enabled) ? "0" : "1"}}>
            <ReCAPTCHA
                size="compact"
                ref={recaptchaRef}
                sitekey="6LfPBUslAAAAAIrLp814HpBIixMj0rL5J3cAxEUw"
                onChange={onChange}
            />
            </div>
            <br />
            <Button disabled={!enabled} loading={loading} onClick={() => {
                setOpen(true)
                }} type="primary" block ><strong>Pay Now</strong></Button>



            <LoadingOverlay loading={loading} />
        </>
    )
}